/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { NullableMoneyOutput } from './NullableMoneyOutput';
import {
    NullableMoneyOutputFromJSON,
    NullableMoneyOutputFromJSONTyped,
    NullableMoneyOutputToJSON,
    NullableMoneyOutputToJSONTyped,
} from './NullableMoneyOutput';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';

/**
 * 
 * @export
 * @interface TopChannel
 */
export interface TopChannel {
    /**
     * 
     * @type {string}
     * @memberof TopChannel
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof TopChannel
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    pnoNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    pnoGross?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TopChannel
     */
    purchaseCostCompleteNet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TopChannel
     */
    purchaseCostCompleteGross?: boolean;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof TopChannel
     */
    profitNet?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof TopChannel
     */
    profitGross?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    profitPercentNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    profitPercentGross?: number | null;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof TopChannel
     */
    mediaSourceQuality?: MediaSourceQuality;
    /**
     * 
     * @type {TopChannelFinanceScopeEnum}
     * @memberof TopChannel
     */
    financeScope?: TopChannelFinanceScopeEnum;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    spendMarketing?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    spendGoodsNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    spendGoodsGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    turnoverGross?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    ordersNet?: number;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    ordersGross?: number;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    purchaseCostUnknownNet?: number;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    purchaseCostUnknownGross?: number;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    purchaseCostEstimatedNet?: number;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    purchaseCostEstimatedGross?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TopChannel
     */
    purchaseCostQualityAvailable?: boolean;
}


/**
 * @export
 */
export const TopChannelFinanceScopeEnum = {
    CanonicalSelected: 'canonical_selected'
} as const;
export type TopChannelFinanceScopeEnum = typeof TopChannelFinanceScopeEnum[keyof typeof TopChannelFinanceScopeEnum];


/**
 * Check if a given object implements the TopChannel interface.
 */
export function instanceOfTopChannel(value: object): value is TopChannel {
    return true;
}

export function TopChannelFromJSON(json: any): TopChannel {
    return TopChannelFromJSONTyped(json, false);
}

export function TopChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] == null ? undefined : json['currency'],
        'name': json['name'] == null ? undefined : json['name'],
        'pnoNet': json['pnoNet'] === undefined ? undefined : json['pnoNet'] === null ? null : json['pnoNet'],
        'pnoGross': json['pnoGross'] === undefined ? undefined : json['pnoGross'] === null ? null : json['pnoGross'],
        'purchaseCostCompleteNet': json['purchaseCostCompleteNet'] == null ? undefined : json['purchaseCostCompleteNet'],
        'purchaseCostCompleteGross': json['purchaseCostCompleteGross'] == null ? undefined : json['purchaseCostCompleteGross'],
        'profitNet': json['profitNet'] === undefined ? undefined : json['profitNet'] === null ? null : NullableMoneyOutputFromJSON(json['profitNet']),
        'profitGross': json['profitGross'] === undefined ? undefined : json['profitGross'] === null ? null : NullableMoneyOutputFromJSON(json['profitGross']),
        'profitPercentNet': json['profitPercentNet'] === undefined ? undefined : json['profitPercentNet'] === null ? null : json['profitPercentNet'],
        'profitPercentGross': json['profitPercentGross'] === undefined ? undefined : json['profitPercentGross'] === null ? null : json['profitPercentGross'],
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyOutputFromJSON(json['spendMarketing']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsGross']),
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
        'ordersNet': json['ordersNet'] == null ? undefined : json['ordersNet'],
        'ordersGross': json['ordersGross'] == null ? undefined : json['ordersGross'],
        'purchaseCostUnknownNet': json['purchaseCostUnknownNet'] == null ? undefined : json['purchaseCostUnknownNet'],
        'purchaseCostUnknownGross': json['purchaseCostUnknownGross'] == null ? undefined : json['purchaseCostUnknownGross'],
        'purchaseCostEstimatedNet': json['purchaseCostEstimatedNet'] == null ? undefined : json['purchaseCostEstimatedNet'],
        'purchaseCostEstimatedGross': json['purchaseCostEstimatedGross'] == null ? undefined : json['purchaseCostEstimatedGross'],
        'purchaseCostQualityAvailable': json['purchaseCostQualityAvailable'] == null ? undefined : json['purchaseCostQualityAvailable'],
    };
}

export function TopChannelToJSON(json: any): TopChannel {
    return TopChannelToJSONTyped(json, false);
}

export function TopChannelToJSONTyped(value?: TopChannel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currency': value['currency'],
        'name': value['name'],
        'pnoNet': value['pnoNet'],
        'pnoGross': value['pnoGross'],
        'purchaseCostCompleteNet': value['purchaseCostCompleteNet'],
        'purchaseCostCompleteGross': value['purchaseCostCompleteGross'],
        'profitNet': NullableMoneyOutputToJSON(value['profitNet']),
        'profitGross': NullableMoneyOutputToJSON(value['profitGross']),
        'profitPercentNet': value['profitPercentNet'],
        'profitPercentGross': value['profitPercentGross'],
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
        'financeScope': value['financeScope'],
        'spendMarketing': MoneyOutputToJSON(value['spendMarketing']),
        'spendGoodsNet': MoneyOutputToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyOutputToJSON(value['spendGoodsGross']),
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
        'ordersNet': value['ordersNet'],
        'ordersGross': value['ordersGross'],
        'purchaseCostUnknownNet': value['purchaseCostUnknownNet'],
        'purchaseCostUnknownGross': value['purchaseCostUnknownGross'],
        'purchaseCostEstimatedNet': value['purchaseCostEstimatedNet'],
        'purchaseCostEstimatedGross': value['purchaseCostEstimatedGross'],
        'purchaseCostQualityAvailable': value['purchaseCostQualityAvailable'],
    };
}

